module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM17.716 16.688l-6.7 7.016a.94.94 0 0 1-1.368 0L8.28 22.27a1.046 1.046 0 0 1 0-1.432l4.646-4.868-4.588-4.81a1.043 1.043 0 0 1 0-1.43l1.368-1.434a.933.933 0 0 1 1.368 0l6.644 6.958a1.05 1.05 0 0 1-.002 1.434zM24 23a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/next-1.js
// module id = 1303
// module chunks = 14